import { store } from '../../../../../resources/frontend/js/store/index';
import { sendLead } from '@form/utils/send-lead';

export const setupRecaptcha = async LeadSystemData => {
    await addRecaptchaScript();

    grecaptcha.ready(() => {
        grecaptcha.execute(store.state.page.recaptchaKey, { action: 'submit' }).then(token => {
            LeadSystemData.append('recaptchaToken', token);
            sendLead(LeadSystemData);
        });
    });
};

export const addRecaptchaScript = () => {
    return new Promise(resolve => {
        let recaptchaReady = false;
        window.recaptchaLoaded = () => {
            recaptchaReady = true;
        };

        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${store.state.page.recaptchaKey}&onload=recaptchaLoaded`;
        script.async = true;
        document.head.appendChild(script);

        const checkRecaptchaReady = setInterval(() => {
            if (recaptchaReady) {
                clearInterval(checkRecaptchaReady);
                resolve();
            }
        }, 100);
    });
};
